<!-- @using Orelap.Models.ReportViewModels
@model AttachedReportViewModel -->

<div class="row">
    <div class="col-sm-1">
        <img src="~/Images/ORELAP.jpg" height="110" alt="Orelap Oregon Health Authority Seal" />
    </div>
    <div class="col-sm-9">
        <div class="row">
            <div class="col-sm-12" style="text-align:center">
                <span style="font-size:30px">
                    <strong>OREGON</strong>
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12" style="text-align:center">
                <span style="font-size:24px">
                    <strong><u>Environmental Laboratory Accreditation Program</u></strong>
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12" style="text-align:center">
                <span style="font-size:24px">
                    <strong>ORELAP Fields of Accreditation</strong>
                </span>
            </div>
        </div>
        <!-- @* -->
        <div class="row">
            <div class="col-sm-7">
                <span class="pull-right" style="font-size:24px">
                    <strong>ORELAP Fields of Accreditation</strong>
                </span>
            </div>
            <div class="col-sm-5">
                <span class="pull-right" style="font-size:24px">
                    <strong>ORELAP ID: </strong> 
                    <!-- @Model.OrelapId -->
                </span>
            </div>
        </div>
        <!-- *@ -->
    </div>
    <div class="col-sm-1">
        <img src="~/Images/nelap2.jpg" height="110" alt="Nelap Recognized" />
    </div>
    <div class="col-sm-1"></div>
</div>

<div class="row">
    <div class="col-sm-7">
        <div class="row">
            <div class="col-sm-12">
                <span style="font-size:24px"><u>
                    <!-- @Model.LabName -->
                    </u>
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <span style="font-size:14pt"><!-- @Model.SiteAddress --></span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <span style="font-size:14pt"><!-- @Model.SiteCity, @Model.SiteState @Model.SiteZip --></span>
            </div>
        </div>
    </div>
    <div class="col-sm-5">
        <div class="row">
            <!-- @* -->
            <div class="col-sm-4">
                <span class="pull-right" style="font-size:24px"><strong>ORELAP ID:</strong></span>
            </div>
            <div class="col-sm-4">
                <span class="pull-left" style="font-size:24px"><!-- @Model.OrelapId --></span>
            </div>
            <!-- *@ -->

            <div class="col-sm-12">
                <span class="pull-right" style="font-size:24px"><strong>ORELAP ID: </strong> <!-- @Model.OrelapId --></span>
            </div>
        </div>
        <!-- @* -->
        <div class="row">
            <div class="col-sm-4">
                <span class="pull-right" style="font-size:24px"><strong>EPA CODE: </strong></span>
            </div>
            <div class="col-sm-4">
                <span class="pull-left" style="font-size:24px"><!-- @Model.EpaId --></span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4">
                <span class="pull-right" style="font-size:24px"><strong>Certificate: </strong></span>
            </div>
            <div class="col-sm-4">
                <span class="pull-left" style="font-size:24px"><!-- @Model.CertificateNumber --></span>
            </div>
        </div>
        <!-- *@ -->
        <div class="row">
            <div class="col-sm-12">
                <span class="pull-right" style="font-size:24px"><strong>EPA CODE: </strong> <!-- @Model.EpaId --></span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <span class="pull-right" style="font-size:24px"><strong>Certificate: </strong> <!-- @Model.CertificateNumber --></span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <span class="pull-right" style="font-size:12pt">Issue Date: <!-- @Model.IssueDate --> &nbsp; Expiration Date: <!-- @Model.ExpirationDate --></span>
            </div>
        </div>
    </div>
    <!-- @*<div class="col-sm-2"></div>*@ -->
</div>

<div class="row">
    <div class="col-sm-12">
        <span style="font-size:14pt"><strong>As of <!-- @Model.IssueDate --> this list supersedes all previous lists for this certificate number.</strong></span>
    </div>
</div>